import { render } from "./studioAchievement.vue?vue&type=template&id=599ed5b1&scoped=true"
import script from "./studioAchievement.vue?vue&type=script&lang=js"
export * from "./studioAchievement.vue?vue&type=script&lang=js"

import "./studioAchievement.vue?vue&type=style&index=0&id=599ed5b1&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599ed5b1"]])

export default __exports__